import React, { forwardRef } from "react";

/** Lib Imports */
import { Card } from "primereact/card";
import PropTypes from "prop-types";
/** Components */
import ApplicantList from "../applicants/components/ApplicantList";

/** ENUM */
import {ApplicantStatus} from "../../enums/ApplicantStatus.ENUM";

const FollowUpApplicant = forwardRef(
  ({ filters, searchApplicant, activeTab }, ref) => {
    return (
      <Card className="height-full-grid-with-searchbar follow-up-applicant-section">
        <div className="page-header">
          <div className="left-title-part">
            <h2 className="card-title  ">Follow-Up Candidates</h2>
          </div>
        </div>
        <ApplicantList
          ref={ref}
          statusId={ApplicantStatus.FOLLOW_UP}
          filters={filters}
          searchApplicant={searchApplicant}
          activeTab={activeTab}
        />
      </Card>
    );
  },
);

FollowUpApplicant.propTypes = {
  filters: PropTypes.object,
  searchApplicant: PropTypes.func,
  activeTab: PropTypes.any,
};
export default FollowUpApplicant;
